<div class="modal-header" style="display:flex;">
    <h3 class="modal-title">View Attachment</h3>
</div>
<div class="modal-body" id="modalSize">
    <div class="row" *ngIf="alert">
        <div class="col-md-12">
            <div class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-warning' : alert.type == 'warning', 'alert-danger': alert.type == 'danger' }" role="alert">
                {{alert.msg}}
                <button type="button" class="close" (click)="closeAlert()">
                    <i class="modus-icons">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="content-wrapper">
        <ejs-pdfviewer id="pdfViewerModal" *ngIf="showViewer"
                       [resourceUrl]='pdfResource'
                       [documentPath]=''
                       [enableFormFields]='false'
                       [enableFormDesignerToolbar]='false'
                       [enableDownload]="true"
                       [enablePrint]="true"
                       [printMode]="printMode"
                       [isSignatureEditable]="false"
                       style="height:640px;display:block">
        </ejs-pdfviewer>

        <a href="/ReportGateway/GetVistaAttachment_Download?attachmentId={{attachmentId}}&rid={{rid}}&rsid={{rsid}}">{{fileName}}</a>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="mb-1 btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>
